/**
 * @generated SignedSource<<d0cd1e7a2b62f5a0ab6e9cae60e44512>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AclInputEntry = {
  actions: ReadonlyArray<string>;
  role: string;
};
export type SeriesAccessAclMutation$variables = {
  acl: ReadonlyArray<AclInputEntry>;
  id: string;
};
export type SeriesAccessAclMutation$data = {
  readonly updateSeriesAcl: {
    readonly acl: ReadonlyArray<{
      readonly actions: ReadonlyArray<string>;
      readonly info: {
        readonly implies: ReadonlyArray<string> | null | undefined;
        readonly label: { default: string } & Record<string, string | undefined>;
        readonly large: boolean;
      } | null | undefined;
      readonly role: string;
    }> | null | undefined;
  };
};
export type SeriesAccessAclMutation = {
  response: SeriesAccessAclMutation$data;
  variables: SeriesAccessAclMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acl"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "acl",
    "variableName": "acl"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AclItem",
  "kind": "LinkedField",
  "name": "acl",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleInfo",
      "kind": "LinkedField",
      "name": "info",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "implies",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "large",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SeriesAccessAclMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Series",
        "kind": "LinkedField",
        "name": "updateSeriesAcl",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SeriesAccessAclMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Series",
        "kind": "LinkedField",
        "name": "updateSeriesAcl",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5dfe1e933dd9a4f231e41abe7f541862",
    "id": null,
    "metadata": {},
    "name": "SeriesAccessAclMutation",
    "operationKind": "mutation",
    "text": "mutation SeriesAccessAclMutation(\n  $id: ID!\n  $acl: [AclInputEntry!]!\n) {\n  updateSeriesAcl(id: $id, acl: $acl) {\n    acl {\n      role\n      actions\n      info {\n        label\n        implies\n        large\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0446a533b6a0b6a54825e1c13ad5cfc2";

export default node;
